import { Image, Paper, Text, Title } from "@mantine/core";
import EthereumBackground from "../../../images/ethereum_background.jpg";
import { dateFormat } from "../../../helpers/Helpers";
import { Link } from "react-router-dom";

export default function ContestDetailedCard({contest}) { 
    // Convert PostgreSQL timestamp to JavaScript Date object
    let endTime = new Date(contest.endat);
    let currentTime = new Date();
    const contestLink = `/contest/${contest.name}`;

    return (
        <Link to={contestLink}>
            <Paper radius={16} shadow="xs" withBorder>
                <Image radius="16px 16px 0px 0px" alt="background" src={EthereumBackground} height={150} />
                <Title mx="md" mt="xs" order={3}>{contest.name}</Title>
                {currentTime >= endTime
                    ? <Text mb="sm" mx="md">Ended {dateFormat(endTime)}</Text>
                    : <Text mb="sm" mx="md">Ongoing</Text>}
            </Paper>
        </Link>
    )
}
